import { useState } from 'react';
import ChoferVehiculoAsignadoTab from '../../Tabs/ChoferVehiculoAsignadoTab';

const tabsList = [
    { key: 'vehiculoAsignado', label: 'Vehículo Asignado' },
];

export default function ChoferTabs({ choferId }) {
    const [active, setActive] = useState('vehiculoAsignado');
    const hasValidContext = Number(choferId || 0) > 0;

    if (!hasValidContext) {
        return (
            <div className="person-tabs-disabled">
                <span>
                    Selecciona o crea un chofer y pulsa <b>Editar</b> para gestionar sus datos relacionados.
                </span>
            </div>
        );
    }

    return (
        <div className="person-tabs-wrap">
            <div className="person-tabs-bar">
                {tabsList.map((t) => (
                    <button
                        key={t.key}
                        className={`person-tab ${active === t.key ? 'is-active' : ''}`}
                        onClick={() => setActive(t.key)}
                    >
                        {t.label}
                    </button>
                ))}
            </div>

            <div className="person-tab-panel">
                {active === 'vehiculoAsignado' && <ChoferVehiculoAsignadoTab fkValue={choferId} />}
            </div>
        </div>
    );
}
